module.exports = __webpack_public_path__ + "img/play-bar.e5a7a142.png";